export const CP_TYPE_KAKAOTV = 'tvpot';
export const CP_TYPE_YOUTUBE = 'youtube';
export const CP_TYPE_ETC     = 'etc';


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/cp-meta/types.js
 **/